import React, { SetStateAction, useEffect, useState } from "react";
import Grid from "@origyn-sa/common-ui/src/components/atoms/Grid";
import SearchInput from "@origyn-sa/common-ui/src/components/molecules/SearchInput";
import Select from "@origyn-sa/common-ui/src/components/molecules/Select";
import CollectionCard from "@origyn-sa/common-ui/src/components/templates/CollectionCard";
import PageTitle from "@origyn-sa/common-ui/src/components/atoms/PageTitle";
import { fetchCollections } from "../../utils";
import Text from "@origyn-sa/common-ui/src/components/atoms/Text";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import { ReactComponent as Add } from "@origyn-sa/common-ui/src/assets/icons/add.svg";
import { LinearProgress } from "@material-ui/core";
import CollectionModal from "./CollectionModal";

const MarketplaceCollections = () => {
  const [loader, setLoader] = useState<boolean>(true);
  const [isAddOpened, setIsAddOpened] = useState<boolean>(false);
  const [collections, setCollections] = useState<any[]>([]);
  const [editItem, setEditItem]: [
    { [key: string]: any } | null,
    SetStateAction<any>
  ] = useState(null);

  const refreshCollections = () => {
    setLoader(true);
    fetchCollections()
      .then((data: any) => {
        console.debug({ msg: "fetchCOllections", data });
        setCollections(data);
      })
      .finally(() => setLoader(false));
  };

  useEffect(() => {
    console.debug("pre::fetchCollections");
    const interval = setInterval(() => refreshCollections(), 10000);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setIsAddOpened(false);
    setEditItem(null);
  };

  const onUpdate = () => {
    fetchCollections().then((data: any) => {
      console.debug({ data });
      setCollections(data);
    });
  };
  const handleEditCollection = (item: { [key: string]: any }) => {
    setEditItem(item);
    setIsAddOpened(true);
  };

  return (
    <>
      {loader && (
        <LinearProgress
          style={{ width: "100%", position: "fixed", left: 0, top: 0 }}
        />
      )}
      <PageTitle>
        Collections{" "}
        <Button onClick={() => setIsAddOpened(true)} outlined small>
          <Add /> Add
        </Button>
        <CollectionModal
          open={isAddOpened}
          onUpdate={onUpdate}
          onClose={handleCloseModal}
          initData={editItem}
        />
      </PageTitle>
      <Grid columns={2}>
        <Grid columns={5} style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
          <SearchInput
            placeholder='Search collections'
            style={{ gridColumnStart: 1, gridColumnEnd: 5 }}
          />
          <Select small placeholder='Sort by' />
        </Grid>
        {collections.length ? (
          collections.map((item: any) => (
            <CollectionCard
              item={item}
              handleEditCollection={handleEditCollection}
            />
          ))
        ) : (
          <Text>No collection.</Text>
        )}
      </Grid>
    </>
  );
};

export default MarketplaceCollections;
